var req = require("!!/__w/30/s/node_modules/pug-loader/index.js!/__w/30/s/src/app/device-settings/device-settings-general-item/device-settings-general-item.component.pug");
module.exports = (req['default'] || req).apply(req, [])